import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import { convertPxToRem, measurePxText } from '../../../Common/Utilties/StringUtility'
const MediaWrap = styled.div`
  display: flex; /* 横並び */
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  color: #000;
  font-size: ${props => props.dialog ? '1.2vw;': '0.8vw;'};
  text-align: center;
  align-items: center;
  width: ${props => props.dialog ? '1084px': '550px;'};
  margin: 4px;
  box-shadow: 0 0 3px 2px ${props => props.selected ? 'rgba(0,128,0,0.8)' : 'rgba(0,0,0,0.4)'};
`
const MediaItem = styled.div`
  display: flex; /* 縦並び */
  flex-direction: column;
  height: 40px;
  border-right: ${props => props.borderNone ? '': '1px solid #000'};
`

const TextWrap = styled.div`
  margin: auto;
  text-overflow: ellipsis; /* 見切れ対策 */
  overflow: hidden;
  white-space: nowrap;
` 

const MaterialHandlingItem = (props) => {
  const {
    searchDate,
    data,type,dialog,index
  } = props

  // 初期値
  useEffect(() => {
  })
  const createElementName = (name,num) => {
    if (name) {
      let text = name
      let textPx = measurePxText(text,props.dialog ? '1.2vw;': '0.8vw;')
      let textRem = convertPxToRem(textPx)
      let checkRem = num
      if (textRem < checkRem)
      {
        return <>{name}</>
      }
  
      let editedText = text
      while (textRem > checkRem) {
        editedText = editedText.slice(0, -1)
        textPx = measurePxText(editedText + '...',props.dialog ? '1.2vw;': '0.8vw;')
        textRem = convertPxToRem(textPx)
        console.log(textRem,checkRem,editedText)
      }
  
      editedText = editedText + '...'
  
      return <Tooltip title={text}><div>{editedText}</div></Tooltip>
    }

    return <></>
  }

  //if (!data) return null;
  //console.log(data);
  return (
    <MediaWrap dialog={dialog}>
      <MediaItem>
        <TextWrap style={{width:dialog?'84px':'42px', textAlign:'center'}}>
          <div>{index}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:dialog?'200px':'100px', textAlign:'center'}}>
          <div>{createElementName(data.companyName,props.dialog?8:6)}</div>
        </TextWrap>
      </MediaItem>
      <MediaItem>
        <TextWrap style={{width:dialog?'200px':'100px', textAlign:'center'}}>
        <div>{createElementName(data.driverName,props.dialog?8:6)}</div>
        </TextWrap>
      </MediaItem>
      {type!=1 &&
        <>
          <MediaItem>
            <TextWrap style={{width:dialog?'400px':'200px', textAlign:'center'}}>
            <div>{createElementName(data.storeName,props.dialog?17:12)}</div>
            </TextWrap>
          </MediaItem>
        </>
      }
      {type==1 &&
        <>
          <MediaItem>
            <TextWrap style={{width:dialog?'200px':'98px', textAlign:'center'}}>
             <div>{createElementName(data.storeName,props.dialog?8:6)}</div>
            </TextWrap>
          </MediaItem>
          <MediaItem>
            <TextWrap style={{width:dialog?'200px':'98px', textAlign:'center'}}>
              <div>{data.work}</div>
            </TextWrap>
          </MediaItem>
        </>
      }
      <MediaItem borderNone={true}>
        <TextWrap style={{width:dialog?'195px':'94px', textAlign:'center'}}>
          <div>{data.time}</div>
        </TextWrap>
      </MediaItem>
    </MediaWrap>
  )
}

MaterialHandlingItem.propTypes = {
}

export default MaterialHandlingItem
